import * as React from 'react';
import { styled } from '@mui/material/styles';
import {default as MuiCheckbox} from '@mui/material/Checkbox';
import "./checkbox.styles.scss";

const BpIcon = styled('span')({
  borderRadius: 2,
  width: 28,
  height: 28,
  border:'1px solid var(--text-color-secondary-2)',
  backgroundColor: '#fff',
  backgroundImage:'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
  'input:disabled ~ &': {
    boxShadow: 'none',
    display:'none',
  },
});

const BpCheckedIcon = styled(BpIcon)({
  backgroundColor: 'var(--color-primary)',
  border:'1px solid var(--color-primary)',
  backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
  '&:before': {
    display: 'block',
    width: 23,
    height: 23,
    marginLeft:2,
    marginTop: 2,
    backgroundImage:
      "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
      " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
      "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
    content: '""',
  },
});

const BpIconSmall = styled('span')({
  borderRadius: 2,
  width: 18,
  height: 18,
  border:'1px solid var(--text-color-secondary-2)',
  backgroundColor: '#fff',
  backgroundImage:'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
  'input:disabled ~ &': {
    boxShadow: 'none',
    display:'none',
  },
});

const BpCheckedIconSmall = styled(BpIconSmall)({
  backgroundColor: '$Main-color',
  border:'1px solid $Main-color',
  backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
  '&:before': {
    display: 'block',
    width: 15,
    height: 15,
    marginLeft:2,
    marginTop: 2,
    backgroundImage:
      "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
      " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
      "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
    content: '""',
  },
});


const BpIconXSmall = styled('span')({
  borderRadius: 2,
  width: 13,
  height: 13,
  border:'1px solid var(--text-color-secondary-4)',
  backgroundColor: '#fff',
  backgroundImage:'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
  'input:disabled ~ &': {
    boxShadow: 'none',
    display:'none',
  },
});

const BpCheckedIconXSmall = styled(BpIconXSmall)({
  backgroundColor: 'var(--color-primary)',
  border:'1px solid var(--color-primary)',
  backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
  '&:before': {
    display: 'block',
    width: 12,
    height: 12,
    backgroundImage:
      "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
      " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
      "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
    content: '""',
  },
});

// Inspired by blueprintjs
function BpCheckbox(props) {
  return (
    <MuiCheckbox
      sx={{
        paddingRight: 0,
        '&:hover': { bgcolor: 'transparent' },
      }}
      disableRipple
      color="default"
      checkedIcon={<BpCheckedIcon />}
      icon={<BpIcon />}
      inputProps={{ 'aria-label': 'Checkbox' }}
      {...props}
    />
  );
}

function BpCheckboxSmall(props) {
  return (
    <MuiCheckbox
      sx={{
        paddingRight: 0,
        '&:hover': { bgcolor: 'transparent' },
      }}
      disableRipple
      color="default"
      checkedIcon={<BpCheckedIconSmall />}
      icon={<BpIconSmall />}
      inputProps={{ 'aria-label': 'Checkbox' }}
      {...props}
    />
  );
}

function BpCheckboxXSmall(props) {
  return (
    <MuiCheckbox
      sx={{
        paddingRight: 0,
        '&:hover': { bgcolor: 'transparent' },
      }}
      disableRipple
      color="default"
      checkedIcon={<BpCheckedIconXSmall />}
      icon={<BpIconXSmall />}
      inputProps={{ 'aria-label': 'Checkbox' }}
      {...props}
    />
  );
}

export default function Checkbox(props) {
  const {name, ...others} = props;
  const checkboxName = name?name:"checkbox";
  if(props.x_small){
    return (
      <div className='checkbox-container input-checkbox-container x-small'>
        <BpCheckboxXSmall name={checkboxName} {...others}/>
        {props.label?<div style={{marginLeft:"10px", opacity:'0.6', width:'calc(100% - 25px)'}} dangerouslySetInnerHTML={{__html:props.label}}></div>:null}
      </div>
    );
  }else if(props.small){
    return (
      <div className='checkbox-container input-checkbox-container small'>
        <BpCheckboxSmall name={checkboxName} {...others}/>
        {props.label?<div style={{marginLeft:"10px", width:'calc(100% - 36px)'}} dangerouslySetInnerHTML={{__html:props.label}}></div>:null}
      </div>
    );
  }else if(props.large){
    return (
      <div className='checkbox-container input-checkbox-container large'>
        <BpCheckbox name={checkboxName} {...others}/>
        {props.label?<div style={{marginLeft:"10px", width:'calc(100% - 40px)'}} dangerouslySetInnerHTML={{__html:props.label}}></div>:null}
      </div>
    );
  } else{ 
    return (
      <div className='checkbox-container input-checkbox-container medium'>
        <BpCheckbox name={checkboxName} {...others}/>
        {props.label?<div style={{marginLeft:"10px", width:'calc(100% - 40px)'}} dangerouslySetInnerHTML={{__html:props.label}}></div>:null}
      </div>
    );
  }
}